export default class SharedContactUsClass {
  constructor(
    public title: string = '',
    public description: string = '',
    public contact_button_text: string = '',
    public phone_number_title: string = '',
    public phone_number: string = '',
    public emait_title: string = '',
    public email_address: string = '',
    public opening_hours_title: string = '',
    public opening_hours: string = ''
  ) {}
}
